import React, { FC } from 'react';
import { AnalyticsTimeComparisonProps } from './AnalyticsTimeComparisonProps';
import { PieChart } from '@mui/x-charts';
import { formatToTime } from '../AnalyticsPagesTimeSpent/utils';
import AnalyticsLoader from '../AnalyticsLoader';

const AnalyticsTimeComparison: FC<AnalyticsTimeComparisonProps> = ({
  data,
  loading,
}) => {
  return (
    <AnalyticsLoader loading={loading}>
      <PieChart
        series={[
          {
            data: [
              { id: 0, value: data?.bulk, label: 'Bulk' },
              { id: 1, value: data?.modal, label: 'Modal' },
            ],
            cx: '60%',
            cy: '60%',
            outerRadius: 150,
            paddingAngle: 1,
            cornerRadius: 3,
            valueFormatter: (value) => formatToTime(value.value),
          },
        ]}
        slotProps={{
          legend: {
            direction: 'row',
            position: { vertical: 'top', horizontal: 'middle' },
          },
        }}
        slots={{
          noDataOverlay: () => null,
        }}
      />
    </AnalyticsLoader>
  );
};

export default AnalyticsTimeComparison;
